import config from '../config';

const CDN_SAFE_FILE_PREFIXES = [
    '/files/feature-assets/',
    '/files/profile-pics/',
];

const CDN_BYPASS_FILE_PREFIXES = [
    '/files/feature-assets/template-images/',
];

const isAbsoluteUrl = (url) => /^https?:\/\//i.test(String(url || ''));

const isLocalEnv = () => config.nodeEnv === 'local' || config.nodeEnv === 'development';

const extractFilesPath = (url) => {
    const normalizedUrl = String(url || '').trim();
    if (!normalizedUrl) return '';

    if (normalizedUrl.startsWith('/files/')) {
        return normalizedUrl;
    }

    if (!isAbsoluteUrl(normalizedUrl)) {
        return '';
    }

    try {
        const parsedUrl = new URL(normalizedUrl);
        return parsedUrl.pathname.startsWith('/files/') ? `${parsedUrl.pathname}${parsedUrl.search}` : '';
    } catch (_error) {
        return '';
    }
};

const normalizeLegacyFilesPath = (filesPath) => {
    const normalizedPath = String(filesPath || '').trim();
    const [pathWithoutQuery, queryString = ''] = normalizedPath.split('?');
    if (!pathWithoutQuery.startsWith('/files/')) {
        return normalizedPath;
    }

    if (
        pathWithoutQuery.startsWith('/files/feature-assets/')
        || pathWithoutQuery.startsWith('/files/profile-pics/')
    ) {
        return normalizedPath;
    }

    if (pathWithoutQuery.startsWith('/files/template-images/')) {
        return `${pathWithoutQuery.replace('/files/template-images/', '/files/feature-assets/template-images/')}${queryString ? `?${queryString}` : ''}`;
    }

    if (pathWithoutQuery.startsWith('/files/category-images/')) {
        return `${pathWithoutQuery.replace('/files/category-images/', '/files/feature-assets/category-images/')}${queryString ? `?${queryString}` : ''}`;
    }

    if (pathWithoutQuery.startsWith('/files/site-banners/')) {
        return `${pathWithoutQuery.replace('/files/site-banners/', '/files/feature-assets/site-banners/')}${queryString ? `?${queryString}` : ''}`;
    }

    const filename = pathWithoutQuery.split('/').pop() || '';
    if (filename.startsWith('template-')) {
        return `/files/feature-assets/template-images/${filename}${queryString ? `?${queryString}` : ''}`;
    }

    if (filename.startsWith('category-')) {
        return `/files/feature-assets/category-images/${filename}${queryString ? `?${queryString}` : ''}`;
    }

    if (filename.startsWith('banner-')) {
        return `/files/feature-assets/site-banners/${filename}${queryString ? `?${queryString}` : ''}`;
    }

    return normalizedPath;
};

export const toDisplayAssetUrl = (url) => {
    const normalizedUrl = String(url || '').trim();
    if (!normalizedUrl) return '';
    const filesPath = extractFilesPath(normalizedUrl);

    if (filesPath) {
        const normalizedFilesPath = normalizeLegacyFilesPath(filesPath);
        const shouldBypassCloudFront = CDN_BYPASS_FILE_PREFIXES.some((prefix) => normalizedFilesPath.startsWith(prefix));
        const canUseCloudFront = !isLocalEnv()
            && !shouldBypassCloudFront
            && CDN_SAFE_FILE_PREFIXES.some((prefix) => normalizedFilesPath.startsWith(prefix));

        if (canUseCloudFront) {
            return `${config.cloudfrontBaseUrl}${normalizedFilesPath.replace(/^\/files/, '')}`;
        }

        return `${config.apiBaseUrl}${normalizedFilesPath}`;
    }

    if (isAbsoluteUrl(normalizedUrl)) return normalizedUrl;
    if (!normalizedUrl.startsWith('/')) return normalizedUrl;

    return `${config.apiBaseUrl}${normalizedUrl}`;
};

export default toDisplayAssetUrl;